import { useEffect, useRef, useState, useCallback, memo } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";
import editIcon from "../../assets/Edit.svg";
import editIconWhite from "../../assets/editIconWhite.svg";
import undoIcon from "../../assets/undo.svg";
import Button from "../Button/Button";
import brushDefaultIcon from "../../assets/brush_default.svg";
import brushSize1Icon from "../../assets/brush_size1.svg";
import brushSize2Icon from "../../assets/brush_size2.svg";
import textIcon from "../../assets/T.svg";
import textIconWhite from "../../assets/T-white.svg";
import { PDFDocument } from "pdf-lib";
import Modal from "../Modal/Modal";
//TODO: fix TextBox
// import { useHistory } from "react-router-dom";
import "./PDFRenderer.css";
import InputBox from "../../components/InputBox/InputBox";
import { CloseIcon } from "../../assets/assets";

const MIN_VIEWER_ZOOM = 1;
const MAX_VIEWER_ZOOM = 4;

function PDFRenderer(props) {
  // const history = useHistory();
  const [showColorOptions, setShowColorOptions] = useState(false);
  const [showBrushOptions, setShowBrushOptions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [inputTextMode, setInputTextMode] = useState(false);
  const pointersRef = useRef({});
  const notesInputRef = useRef(null);
  const [page, setPage] = useState(1);
  // const [hasAddedNotes, setHasAddedNotes] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [loadedPDF, setLoadedPDF] = useState(null);
  const [loadedFabric, setLoadedFabric] = useState(null);
  const [isDrawingMode, setIsDrawingMode] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  // const [renderCount, setRenderCount] = useState(0);
  const fabricCanvas = useRef({
    fabric: null,
    arrayBuffer: null,
    pdfLibDoc: null,
    canvas: null,
    zoomScale: 1,
    panning: false,
    lastX: null,
    lastY: null,
    pausePanning: false,
    image: {
      height: 0,
      width: 0
    }
  });
  const canvasContainer = useRef(null);
  const rootContainer = useRef(null);
  const isRendering = useRef(false);
  // pinch-zoom / pan state for the read-only (non-fabric) PDF viewer canvas
  const viewerZoom = useRef({
    scale: MIN_VIEWER_ZOOM,
    x: 0,
    y: 0,
    mode: null, // "pinch" | "pan" | null
    startDistance: 0,
    startScale: MIN_VIEWER_ZOOM,
    startX: 0,
    startY: 0,
    startTranslateX: 0,
    startTranslateY: 0
  });
  const [data, setData] = useState(props.notes ? props.notes : {});
  const [properties, setProperties] = useState({
    color: "rgba(78,78,78,1)",
    rgba: "rgba(78,78,78,0.5)",
    width: 4
  });
  pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

  const loadPDF = async () => {
    setLoadedPDF(null);
    if (typeof props.onPDFChange === "function") {
      props.onPDFChange();
    }
    const loadingTask = pdfjs.getDocument({
      data: props.pdfArrayBuffer
    });
    fabricCanvas.current.pdfLibDoc = await PDFDocument.load(
      props.pdfArrayBuffer
    );
    const pdf = await loadingTask.promise;
    setLoadedPDF(pdf);
  };

  // set editable or not
  useEffect(() => {
    if (
      Object.values(data).length > 0 &&
      props.notes !== null &&
      JSON.stringify(props.notes) !== JSON.stringify(data)
    ) {
      setIsEdited(true);
    } else {
      setIsEdited(false);
    }
    // eslint-disable-next-line
  }, [data]);

  // set loaded fabric
  useEffect(() => {
    if (props.readOnly === false) {
      import("../../services/fabric").then((importedFabric) => {
        fabricCanvas.current.fabric = importedFabric.fabric;
        setLoadedFabric(true);
      });
    }
  }, [props.readOnly]);

  const removePreExistingCanvas = () => {
    document.getElementById("pdfCanvas").remove();
    if (document.getElementById("pdfCanvas")) {
      removePreExistingCanvas();
    }
  };

  const renderPDF = async () => {
    try {
      if (loadedPDF === null) {
        return;
      }
      // if (!rootContainer.current) {
      //   if (renderCount <= 10) {
      //     setRenderCount(renderCount + 1);
      //     renderPDF();
      //   }
      // }
      // setRenderCount(0);
      let pdf = loadedPDF;
      setTotalPages(pdf.numPages);
      const currentPage = await pdf.getPage(page);
      const scale = 2;
      const viewport = currentPage.getViewport({ scale: scale });

      const canvas = document.createElement("canvas");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvas.style.width = "100%";
      canvas.style.height = "auto";
      canvas.id = "pdfCanvas";
      if (props.readOnly === false) {
        canvas.style.display = "none";
      }
      canvas.setAttribute("canvas-state", "CREATED");
      // Render PDF page into canvas context
      const context = canvas.getContext("2d");
      const renderContext = { canvasContext: context, viewport: viewport };
      const renderTask = currentPage.render(renderContext);
      await renderTask.promise;
      if (document.getElementById("pdfCanvas")) {
        removePreExistingCanvas();
        rootContainer.current.appendChild(canvas);
      } else {
        rootContainer.current.appendChild(canvas);
      }
      canvas.setAttribute("canvas-state", "MOUNTED");
      if (props.readOnly !== false) {
        if (typeof props.onRender === "function") {
          props.onRender();
          isRendering.current = false;
        }
        return;
      }

      if (fabricCanvas.current.canvas === null) {
        fabricCanvas.current.canvas = new fabricCanvas.current.fabric.Canvas(
          "canvas",
          {
            width: canvasContainer.current.offsetWidth,
            height:
              (viewport.height / viewport.width) *
              canvasContainer.current.offsetWidth,
            selection: false
          }
        );
      }

      // Set the rendered PDF as background image to FabricJS
      var bg = new Image();
      bg.src = document.getElementById("pdfCanvas").toDataURL("image/png");
      fabricCanvas.current.fabric.Image.fromObject(bg, function (img) {
        fabricCanvas.current.canvas.setBackgroundImage(
          img,
          fabricCanvas.current.canvas.renderAll.bind(
            fabricCanvas.current.canvas
          ),
          {
            scaleX: fabricCanvas.current.canvas.width / img.width,
            scaleY: fabricCanvas.current.canvas.height / img.height
          }
        );

        if (typeof props.onRender === "function" && !data[page]) {
          props.onRender();
        }
        const fabricMountedCanvas = document.getElementById("canvas");
        fabricMountedCanvas.setAttribute("canvas-state", "BG-IMG-PAINTED");
      });

      // Set the existing notes as overlay image to FabricJS
      if (data[page]) {
        fabricCanvas.current.fabric.Image.fromURL(
          data[page],
          function (notesImg) {
            fabricCanvas.current.canvas.setOverlayImage(
              notesImg,
              fabricCanvas.current.canvas.renderAll.bind(
                fabricCanvas.current.canvas
              ),
              {
                scaleX: fabricCanvas.current.canvas.width / notesImg.width,
                scaleY: fabricCanvas.current.canvas.height / notesImg.height
              }
            );
            if (typeof props.onRender === "function") {
              props.onRender();
            }
            const fabricMountedCanvas = document.getElementById("canvas");
            fabricMountedCanvas.setAttribute(
              "canvas-state",
              "OVERLAY-IMG-PAINTED"
            );
          }
        );
      }

      // const fabricMountedCanvas = document.getElementById("canvas");
      // fabricMountedCanvas.setAttribute("canvas-state", "PAINTED");

      fabricCanvas.current.canvas.on({
        "after:render": function (e) {
          const fabricMountedCanvas = document.getElementById("canvas");
          fabricMountedCanvas.setAttribute("canvas-state", "RENDERED");
        }
      });

      // Enable pinch zoom and pan
      fabricCanvas.current.canvas.on({
        "touch:gesture": function (e) {
          if (
            e.e.touches &&
            e.e.touches.length === 2 &&
            fabricCanvas.current.panning === false
          ) {
            var point = new fabricCanvas.current.fabric.Point(
              e.self.x,
              e.self.y
            );
            let scale = 1;
            if (e.self.scale > 1) scale = (e.self.scale % 1) / 10 + 1;
            if (e.self.scale < 1) scale = 1 - (1 - e.self.scale) / 10;
            if (fabricCanvas.current.canvas.getZoom() * scale >= 1) {
              if (fabricCanvas.current.zoomScale !== scale) {
                fabricCanvas.current.zoomScale = scale;
                var delta = fabricCanvas.current.canvas.getZoom() * scale;
                fabricCanvas.current.canvas.zoomToPoint(point, delta);
              }
            } else {
              fabricCanvas.current.canvas.setViewportTransform([
                1, 0, 0, 1, 0, 0
              ]);
            }
          }
        }
      });
      fabricCanvas.current.canvas.on({
        "touch:drag": function (event) {
          var e = event.e;
          if (
            fabricCanvas.current.pausePanning === true ||
            fabricCanvas.current.canvas.isDrawingMode === true ||
            e.touches === undefined ||
            e.touches[0].clientX === undefined ||
            e.touches[0].clientY === undefined ||
            e.touches.length === 2
          ) {
            fabricCanvas.current.panning = false;
            return;
          }
          if (fabricCanvas.current.panning) {
            if (
              fabricCanvas.current.canvas.viewportTransform[4] +
                e.touches[0].clientX -
                fabricCanvas.current.lastX <=
                0 &&
              Math.abs(
                fabricCanvas.current.canvas.viewportTransform[4] +
                  e.touches[0].clientX -
                  fabricCanvas.current.lastX
              ) <
                fabricCanvas.current.canvas.getWidth() *
                  fabricCanvas.current.canvas.getZoom() -
                  fabricCanvas.current.canvas.getWidth()
            ) {
              fabricCanvas.current.canvas.viewportTransform[4] +=
                e.touches[0].clientX - fabricCanvas.current.lastX;
              fabricCanvas.current.lastX = e.touches[0].clientX;
            }
            if (
              fabricCanvas.current.canvas.viewportTransform[5] +
                e.touches[0].clientY -
                fabricCanvas.current.lastY <=
                0 &&
              Math.abs(
                fabricCanvas.current.canvas.viewportTransform[5] +
                  e.touches[0].clientY -
                  fabricCanvas.current.lastY
              ) <
                fabricCanvas.current.canvas.getHeight() *
                  fabricCanvas.current.canvas.getZoom() -
                  fabricCanvas.current.canvas.getHeight()
            ) {
              fabricCanvas.current.canvas.viewportTransform[5] +=
                e.touches[0].clientY - fabricCanvas.current.lastY;
              fabricCanvas.current.lastY = e.touches[0].clientY;
            }
            fabricCanvas.current.canvas.requestRenderAll();
          } else {
            fabricCanvas.current.panning = true;
            fabricCanvas.current.lastX = e.touches[0].clientX;
            fabricCanvas.current.lastY = e.touches[0].clientY;
          }
        }
      });
      fabricCanvas.current.canvas.on({
        "selection:created": function (e) {
          fabricCanvas.current.pausePanning = true;
        }
      });
      fabricCanvas.current.canvas.on({
        "selection:cleared": function (e) {
          fabricCanvas.current.pausePanning = false;
        }
      });
      fabricCanvas.current.canvas.on({
        "object:added": function (e) {
          var activeObject = e.target;
          if (activeObject.type === "path") {
            var lastItemIndex =
              fabricCanvas.current.canvas.getObjects().length - 1;
            var item = fabricCanvas.current.canvas.item(lastItemIndex);
            item.selectable = false;
          }
          setIsEdited(true);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  // const exportData = async () => {
  //   let fileConvertedUrl;
  //   let notesStringObj = {};
  //   if (
  //     fabricCanvas.current.canvas.getObjects().length > 0 ||
  //     hasAddedNotes === true
  //   ) {
  //     fabricCanvas.current.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
  //     fabricCanvas.current.canvas.backgroundImage = null;
  //     fileConvertedUrl = fabricCanvas.current.canvas.toDataURL({
  //       left: 0,
  //       top: 0,
  //       format: "png",
  //       quality: 1
  //     });
  //     notesStringObj = {
  //       ...data,
  //       [page]: fileConvertedUrl
  //     };
  //     setData({
  //       ...data,
  //       [page]: fileConvertedUrl
  //     });

  //     for (const [pageNo, data] of Object.entries(notesStringObj)) {
  //       let image = await fabricCanvas.current.pdfLibDoc.embedPng(
  //         Uint8Array.from(atob(data.split(",")[1]), (c) => c.charCodeAt(0))
  //       );
  //       fabricCanvas.current.pdfLibDoc.getPages()[pageNo - 1].drawImage(image, {
  //         x: 0,
  //         y: 0,
  //         width: fabricCanvas.current.pdfLibDoc
  //           .getPages()
  //           [pageNo - 1].getWidth(),
  //         height: fabricCanvas.current.pdfLibDoc
  //           .getPages()
  //           [pageNo - 1].getHeight()
  //       });
  //     }
  //     const pdfBytes = await fabricCanvas.current.pdfLibDoc.save();
  //     var bytes = new Uint8Array(pdfBytes);
  //     var blob = new Blob([bytes], { type: "application/pdf" });
  //     // const docUrl = URL.createObjectURL(blob);
  //     // window.open(docUrl);
  //     return blob;
  //   }
  // };

  const changeColor = useCallback(() => {
    fabricCanvas.current.canvas.freeDrawingBrush.color = properties.color;
  }, [properties]);

  const changeWidth = useCallback(() => {
    fabricCanvas.current.canvas.freeDrawingBrush.width = properties.width;
  }, [properties]);

  const flipPage = (pageNumber) => {
    if (props.readOnly === false) {
      if (fabricCanvas.current.canvas.getObjects().length > 0) {
        fabricCanvas.current.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        fabricCanvas.current.canvas.backgroundImage = null;
        setData({
          ...data,
          [page]: fabricCanvas.current.canvas.toDataURL({
            left: 0,
            top: 0,
            format: "png",
            quality: 1
          })
        });
        // setHasAddedNotes(true);
      }
      fabricCanvas.current.canvas.overlayImage = null;
      fabricCanvas.current.canvas.renderAll.bind(fabricCanvas.current.canvas);
      clearAll();
    }
    setPage(pageNumber);
  };

  const showNotesInputModal = (e) => {
    const pointer = fabricCanvas.current.canvas.getPointer(e.e);
    pointersRef.current["posX"] = pointer.x;
    pointersRef.current["posY"] = pointer.y;
    fabricCanvas.current.canvas.off("mouse:up", showNotesInputModal);
    setShowModal(true);
  };

  const addText = () => {
    if (notesInputRef.current && notesInputRef.current.trim().length !== 0) {
      var text = new fabricCanvas.current.fabric.Text(notesInputRef.current, {
        left: pointersRef.current.posX,
        top: pointersRef.current.posY,
        textAlign: "center",
        textBackgroundColor: properties.rgba
      });
      fabricCanvas.current.canvas.add(text);
    }
    setShowModal(false);
    setInputTextMode(false);
  };

  const addTextListener = () => {
    setIsDrawingMode(false);
    setInputTextMode(true);
    fabricCanvas.current.canvas.on("mouse:up", showNotesInputModal);
  };

  const undo = () => {
    var lastItemIndex = fabricCanvas.current.canvas.getObjects().length - 1;
    var item = fabricCanvas.current.canvas.item(lastItemIndex);
    if (
      item !== undefined &&
      (item.get("type") === "path" || item.get("type") === "text")
    ) {
      fabricCanvas.current.canvas.remove(item);
      fabricCanvas.current.canvas.renderAll();
    }
  };

  const onSelectColor = (event, r, g, b) => {
    event.stopPropagation();
    setProperties({
      ...properties,
      rgba: `rgba(${r},${g},${b},0.5)`,
      color: `rgba(${r},${g},${b},1)`
    });
    setShowColorOptions(false);
  };

  const onSelectSize = (event, width) => {
    event.stopPropagation();
    setProperties({
      ...properties,
      width: width
    });
    setShowBrushOptions(false);
  };

  const clearAll = () => {
    fabricCanvas.current.canvas.remove(
      ...fabricCanvas.current.canvas.getObjects()
    );
  };

  // --- Pinch zoom / pan for the read-only PDF viewer canvas ---
  // (the fabric canvas used in edit mode already has its own touch:gesture zoom)
  const touchDistance = (touchA, touchB) =>
    Math.hypot(
      touchA.clientX - touchB.clientX,
      touchA.clientY - touchB.clientY
    );

  const applyViewerTransform = () => {
    const canvas = document.getElementById("pdfCanvas");
    if (!canvas) return;
    const { scale, x, y } = viewerZoom.current;
    canvas.style.transformOrigin = "0 0";
    canvas.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
  };

  const clampViewerTranslate = (scale, x, y) => {
    if (!rootContainer.current || scale <= MIN_VIEWER_ZOOM) {
      return { x: 0, y: 0 };
    }
    const { width, height } = rootContainer.current.getBoundingClientRect();
    const minX = Math.min(0, width - width * scale);
    const minY = Math.min(0, height - height * scale);
    return {
      x: Math.min(0, Math.max(minX, x)),
      y: Math.min(0, Math.max(minY, y))
    };
  };

  const handleViewerTouchStart = (e) => {
    const zoom = viewerZoom.current;
    if (e.touches.length === 2) {
      e.preventDefault();
      zoom.mode = "pinch";
      zoom.startDistance = touchDistance(e.touches[0], e.touches[1]);
      zoom.startScale = zoom.scale;
    } else if (e.touches.length === 1 && zoom.scale > MIN_VIEWER_ZOOM) {
      zoom.mode = "pan";
      zoom.startX = e.touches[0].clientX;
      zoom.startY = e.touches[0].clientY;
      zoom.startTranslateX = zoom.x;
      zoom.startTranslateY = zoom.y;
    } else {
      zoom.mode = null;
    }
  };

  const handleViewerTouchMove = (e) => {
    const zoom = viewerZoom.current;
    const container = rootContainer.current;
    if (!container) return;

    if (zoom.mode === "pinch" && e.touches.length === 2) {
      e.preventDefault();
      const distance = touchDistance(e.touches[0], e.touches[1]);
      const nextScale = Math.min(
        MAX_VIEWER_ZOOM,
        Math.max(
          MIN_VIEWER_ZOOM,
          zoom.startScale * (distance / zoom.startDistance)
        )
      );
      const rect = container.getBoundingClientRect();
      const midX =
        (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
      const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;
      const localX = (midX - zoom.x) / zoom.scale;
      const localY = (midY - zoom.y) / zoom.scale;
      const clamped = clampViewerTranslate(
        nextScale,
        midX - localX * nextScale,
        midY - localY * nextScale
      );
      zoom.scale = nextScale;
      zoom.x = clamped.x;
      zoom.y = clamped.y;
      applyViewerTransform();
    } else if (zoom.mode === "pan" && e.touches.length === 1) {
      e.preventDefault();
      const clamped = clampViewerTranslate(
        zoom.scale,
        zoom.startTranslateX + (e.touches[0].clientX - zoom.startX),
        zoom.startTranslateY + (e.touches[0].clientY - zoom.startY)
      );
      zoom.x = clamped.x;
      zoom.y = clamped.y;
      applyViewerTransform();
    }
  };

  const handleViewerTouchEnd = (e) => {
    const zoom = viewerZoom.current;
    if (e.touches.length === 1 && zoom.scale > MIN_VIEWER_ZOOM) {
      // one finger lifted mid-pinch, continue as a pan instead of resetting
      zoom.mode = "pan";
      zoom.startX = e.touches[0].clientX;
      zoom.startY = e.touches[0].clientY;
      zoom.startTranslateX = zoom.x;
      zoom.startTranslateY = zoom.y;
    } else if (e.touches.length === 0) {
      zoom.mode = null;
      if (zoom.scale <= MIN_VIEWER_ZOOM) {
        // pinched back down past 1x: snap cleanly back to the un-zoomed fit
        zoom.scale = MIN_VIEWER_ZOOM;
        zoom.x = 0;
        zoom.y = 0;
        applyViewerTransform();
      }
    }
  };

  const handleViewerWheel = (e) => {
    // supports desktop trackpad pinch (fires as ctrl+wheel)
    if (!e.ctrlKey || !rootContainer.current) return;
    e.preventDefault();
    const zoom = viewerZoom.current;
    const nextScale = Math.min(
      MAX_VIEWER_ZOOM,
      Math.max(MIN_VIEWER_ZOOM, zoom.scale - e.deltaY * 0.01)
    );
    const rect = rootContainer.current.getBoundingClientRect();
    const pointX = e.clientX - rect.left;
    const pointY = e.clientY - rect.top;
    const localX = (pointX - zoom.x) / zoom.scale;
    const localY = (pointY - zoom.y) / zoom.scale;
    const clamped = clampViewerTranslate(
      nextScale,
      pointX - localX * nextScale,
      pointY - localY * nextScale
    );
    zoom.scale = nextScale;
    zoom.x = clamped.x;
    zoom.y = clamped.y;
    applyViewerTransform();
  };

  // to load pdf if array buffer is given
  useEffect(() => {
    if (props.pdfArrayBuffer) {
      loadPDF();
    }
    // eslint-disable-next-line
  }, [props.pdfArrayBuffer]);

  //to render pdf
  useEffect(() => {
    if (props.readOnly !== false) {
      if (loadedPDF !== null && loadedPDF !== undefined) {
        renderPDF();
      }
    } else if (props.readOnly === false) {
      if (
        loadedPDF !== null &&
        loadedPDF !== undefined &&
        loadedFabric === true
      ) {
        renderPDF();
      }
    }
    // eslint-disable-next-line
  }, [loadedPDF, props.readOnly, loadedFabric, page, data]);

  // attach pinch-zoom/pan touch handlers to the read-only viewer container
  useEffect(() => {
    if (props.readOnly === false) return undefined;
    const container = rootContainer.current;
    if (!container) return undefined;
    container.style.touchAction = "none";
    container.addEventListener("touchstart", handleViewerTouchStart, {
      passive: false
    });
    container.addEventListener("touchmove", handleViewerTouchMove, {
      passive: false
    });
    container.addEventListener("touchend", handleViewerTouchEnd);
    container.addEventListener("touchcancel", handleViewerTouchEnd);
    container.addEventListener("wheel", handleViewerWheel, { passive: false });
    return () => {
      container.removeEventListener("touchstart", handleViewerTouchStart);
      container.removeEventListener("touchmove", handleViewerTouchMove);
      container.removeEventListener("touchend", handleViewerTouchEnd);
      container.removeEventListener("touchcancel", handleViewerTouchEnd);
      container.removeEventListener("wheel", handleViewerWheel);
    };
    // eslint-disable-next-line
  }, [loadedPDF, props.readOnly]);

  // reset zoom/pan whenever the visible page changes
  useEffect(() => {
    if (props.readOnly === false) return;
    viewerZoom.current.scale = MIN_VIEWER_ZOOM;
    viewerZoom.current.x = 0;
    viewerZoom.current.y = 0;
    viewerZoom.current.mode = null;
    // eslint-disable-next-line
  }, [page]);

  // set notes data
  useEffect(() => {
    if (props.notes) {
      setData({ ...data, ...props.notes });
    }
    // eslint-disable-next-line
  }, [props.notes]);

  // to change color and width of font in notes
  useEffect(() => {
    if (fabricCanvas.current.canvas) {
      fabricCanvas.current.canvas.isDrawingMode = isDrawingMode;
      changeColor();
      changeWidth();
    }
  }, [isDrawingMode, changeColor, changeWidth]);

  const isDisplayFooter = () => {
    // readOnly true display footer else hide
    if (
      props.readOnly ||
      loadedPDF == null ||
      loadedPDF === undefined ||
      !!!loadedFabric
    ) {
      //don`t Show when readOnly mode is enabled
      return false;
    } else {
      if (!props.readOnly || props.isPrescription) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <>
      <Modal
        onClickClose={() => {
          setShowModal(false);
        }}
        show={showModal}
        position="position-fixed top-0 right-0 bottom-0 left-0"
        boxShadow="none"
        borderRadius="none"
        width="inherit-parent-width"
        background="background-transparent"
        height="inherit-parent-height"
      >
        <main
          data-cy="add-text-modal"
          className="flex-place-children-page-center inherit-parent-width inherit-parent-height padding-larger"
        >
          <div className="inherit-parent-width max-width-500px background-white padding-larger border-radius-default">
            <form
              onChange={(event) => {
                notesInputRef.current = event.target.value;
              }}
              onSubmit={(event) => {
                event.preventDefault();
                addText();
              }}
            >
              <InputBox
                className="inherit-parent-width border-radius-default"
                name="notes"
                label="Notes"
                type="text"
                autoComplete="off"
                autoFocus={true}
              />
            </form>
            <div className="margin-top-larger flex-justify-content-space-between">
              <Button
                id="submit-btn"
                text="Add"
                onClick={() => {
                  addText();
                }}
                boxShadow={false}
                data-cy="add-notes-btn"
              />
              <Button
                className="margin-left-medium"
                text="Cancel"
                variant="secondary"
                onClick={(_) => {
                  fabricCanvas.current.canvas.off(
                    "mouse:up",
                    showNotesInputModal
                  );
                  setShowModal(false);
                  setInputTextMode(false);
                }}
                disabled={false}
                boxShadow={false}
              />
            </div>
          </div>
        </main>
      </Modal>
      {totalPages === 0 || totalPages === 1 || page === 1 ? null : (
        <button
          data-cy="navigate-previous-page"
          className=" position-absolute z-index-1 height-width-30px top-50-percentage transform-translateY--50-percentage border-radius-50-percentage background-color-transparent-black-lite left-3px "
          onClick={() => {
            page > 1 && flipPage(page - 1);
          }}
        >
          <div className="transform-rotate-180-deg inherit-parent-height inherit-parent-width flex-place-children-page-center">
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99994 5.58624C7.78095 6.36726 7.78099 7.63351 7.00003 8.41458L2.12164 13.2936C1.73113 13.6841 1.09795 13.6842 0.707428 13.2936C0.316927 12.9031 0.31693 12.27 0.707434 11.8795L5.58606 7.00082L0.706598 2.12131C0.316083 1.73079 0.316081 1.09764 0.706594 0.707117C1.09711 0.316588 1.73028 0.316584 2.12081 0.707109L6.99994 5.58624Z"
                fill="#ffff"
              />
            </svg>
          </div>

          {/* <img
								src={nextPrevIcon}
								alt="previous_icon"
							/> */}
        </button>
      )}
      {page === totalPages ? null : (
        <button
          data-cy="navigate-next-page"
          className="position-absolute z-index-1 height-width-30px top-50-percentage transform-translateY--50-percentage border-radius-50-percentage background-color-transparent-black-lite right-3px"
          onClick={() => {
            page < totalPages && flipPage(page + 1);
          }}
        >
          <div className="inherit-parent-height inherit-parent-width flex-place-children-page-center">
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99994 5.58624C7.78095 6.36726 7.78099 7.63351 7.00003 8.41458L2.12164 13.2936C1.73113 13.6841 1.09795 13.6842 0.707428 13.2936C0.316927 12.9031 0.31693 12.27 0.707434 11.8795L5.58606 7.00082L0.706598 2.12131C0.316083 1.73079 0.316081 1.09764 0.706594 0.707117C1.09711 0.316588 1.73028 0.316584 2.12081 0.707109L6.99994 5.58624Z"
                fill="#ffff"
              />
            </svg>
          </div>
        </button>
      )}
      {/* Navigation Back PopUp */}
      {/* <Modal
				onClickClose={() => {
					props.setShowWarningModal && props.setShowWarningModal(false)
				}}
				show={props.showWarningModal}
				position="position-fixed top-0 right-0 bottom-0 left-0"
				boxShadow="none"
				borderRadius="none"
				width="inherit-parent-width"
				background="background-transparent"
				height="inherit-parent-height"
			>
				<main
					data-cy="navigation-back-confirmation-modal"
					className="flex-place-children-page-center inherit-parent-width inherit-parent-height padding-larger"
				>
					<div className="inherit-parent-width max-width-500px background-white padding-larger border-radius-default">
						<form
							onChange={(event) => {
								notesInputRef.current = event.target.value;
							}}
							onSubmit={(event) => {
								event.preventDefault();
							}}
						>
							<InputBox
								className="inherit-parent-width border-radius-default"
								name="should"
								label="should"
								type="text"
								autoComplete="off"
								autoFocus={true}
							/>
						</form>
						<div className="margin-top-larger flex-justify-content-space-between">
							<Button
								id="submit-btn"
								text="Add"
								onClick={() => {
								}}
								boxShadow={false}
								data-cy="add-notes-btn"
							/>
							<Button
								className="margin-left-medium"
								text="Cancel"
								variant="secondary"
								onClick={(_) => {
									props.setShowWarningModal(false)
								}}
								disabled={false}
								boxShadow={false}
							/>
						</div>
					</div>
				</main>
			</Modal> */}
      {/*  */}
      {((loadedPDF === null || loadedPDF === undefined) &&
        props.readOnly === true) ||
      ((loadedPDF === null || loadedPDF === undefined) &&
        props.readOnly === false &&
        loadedFabric === false) ? (
        <PDFrendererSuspense />
      ) : (
        <div
          ref={rootContainer}
          data-cy="pdf-renderer-canvas"
          className={`${
            props.readOnly === false
              ? " inherit-parent-height display-flex flex-direction-column position-relative"
              : "height-fit-content margin-auto position-relative overflow-hidden"
          }`}
        >
          <canvas id="pdfCanvas" style={{ display: "none" }} />
          {props.readOnly === false && loadedFabric === true && (
            <div
              ref={canvasContainer}
              className={`flex-grow-1 position-relative flex-place-children-page-center hide-scroll-bar ${
                props.isPrescription ? "justify-content-start" : ""
              }`}
            >
              <canvas id="canvas" />
            </div>
          )}

          {isDisplayFooter() && (
            <>
              <footer
                data-cy="pdf-editing-tools-footer"
                className="margin-top-small background-color-white padding-default flex-place-children-page-center inherit-parent-width box-shadow-default border-top-radius-default"
              >
                <section className="padding-default edit-document-options inherit-parent-width max-width-588px flex-center-children-vertically flex-justify-content-space-between">
                  <button
                    data-cy={`drawing-mode-${
                      isDrawingMode ? "selected" : "unselected"
                    }`}
                    onClick={() => {
                      if (props.loading) return;
                      if (showColorOptions) {
                        setShowColorOptions(false);
                      }
                      if (showBrushOptions) {
                        setShowBrushOptions(false);
                      }

                      if (inputTextMode !== true) {
                        setIsDrawingMode((prevState) => !prevState);
                      }
                    }}
                    className={`${
                      isDrawingMode
                        ? "background-primary "
                        : "background-color-white"
                    }`}
                  >
                    <img
                      src={isDrawingMode ? editIconWhite : editIcon}
                      alt="edit_icon"
                      width={24}
                      height={24}
                    />
                  </button>

                  <button
                    className="edit-btn-with-options flex-place-children-page-center"
                    onClick={() => {
                      if (props.loading) return;
                      if (showColorOptions) {
                        setShowColorOptions(false);
                      }
                      setShowBrushOptions((prevState) => !prevState);
                    }}
                  >
                    <div
                      className={`edit-options-wrapper ${
                        showBrushOptions ? " display-block" : "display-none"
                      }`}
                    >
                      <img
                        src={brushSize2Icon}
                        alt="brush_icon"
                        onClick={(event) => onSelectSize(event, 8)}
                      />
                      <img
                        src={brushSize1Icon}
                        alt="brush_icon"
                        onClick={(event) => onSelectSize(event, 6)}
                      />
                      <img
                        src={brushDefaultIcon}
                        alt="brush_icon"
                        onClick={(event) => onSelectSize(event, 4)}
                      />
                    </div>
                    <img
                      src={
                        properties.width === 8
                          ? brushSize2Icon
                          : properties.width === 6
                          ? brushSize1Icon
                          : brushDefaultIcon
                      }
                      alt="brush_icon"
                    />
                  </button>

                  <button
                    onClick={() => {
                      if (props.loading) return;
                      if (showBrushOptions) {
                        setShowBrushOptions(false);
                      }
                      setShowColorOptions((prevState) => !prevState);
                    }}
                    className="edit-btn-with-options flex-place-children-page-center"
                  >
                    <div
                      className={`edit-options-wrapper ${
                        showColorOptions ? " display-block" : "display-none"
                      } `}
                    >
                      <span
                        className="background-color-black"
                        onClick={(event) => onSelectColor(event, 0, 0, 0)}
                      />
                      <span
                        className="background-color-white"
                        onClick={(event) => onSelectColor(event, 255, 255, 255)}
                      />
                      <span
                        className="background-color-dark-grey"
                        onClick={(event) => onSelectColor(event, 78, 78, 78)}
                      />
                      <span
                        className="background-color-primary-green"
                        onClick={(event) => onSelectColor(event, 0, 200, 128)}
                      />
                      <span
                        className="background-color-red"
                        onClick={(event) => onSelectColor(event, 230, 69, 57)}
                      />
                    </div>
                    <span
                      style={{
                        backgroundColor: properties.color
                      }}
                    />
                  </button>

                  <button
                    data-cy={`add-text-option-btn-${
                      inputTextMode ? "selected" : "unselected"
                    }`}
                    onClick={() => {
                      if (props.loading) return;
                      addTextListener();
                    }}
                    className={`${
                      inputTextMode
                        ? "background-primary "
                        : "background-color-white"
                    }`}
                  >
                    <img
                      src={inputTextMode ? textIconWhite : textIcon}
                      alt="add_text_icon"
                    />
                  </button>

                  <button
                    className="background-color-white"
                    onClick={() => {
                      if (props.loading) return;
                      undo();
                    }}
                  >
                    <img src={undoIcon} alt="undo_icon" />
                  </button>

                  <button
                    className="background-color-white"
                    onClick={() => {
                      if (props.loading) return;
                      clearAll();
                    }}
                  >
                    <CloseIcon />
                  </button>
                </section>

                <section className="inherit-parent-width max-width-588px flex-center-children-vertically flex-justify-content-space-between ">
                  <Button
                    loading={props.loading}
                    id="add-btn"
                    data-cy="save-pdf-btn"
                    text="Save"
                    boxShadow={false}
                    className="margin-small"
                    onClick={async () => {
                      if (!props.loading) {
                        if (showBrushOptions) setShowBrushOptions(false);
                        if (showColorOptions) setShowColorOptions(false);
                        if (isDrawingMode) setIsDrawingMode(false);
                        if (showModal) setShowModal(false);
                        if (inputTextMode) setInputTextMode(false);

                        // const blob = await exportData();
                        // if (blob !== undefined && blob !== null) {
                        //   if (props.isPrescription) {
                        //     typeof props.addPrescription === "function" &&
                        //       props.addPrescription(blob, history);
                        //   } else {
                        //     typeof props.addNotes === "function" &&
                        //       props.addNotes(
                        //         {
                        //           pdfBlob: blob,
                        //           isDraft: false
                        //         },
                        //         history
                        //       );
                        //   }
                        // }
                      }
                    }}
                    disabled={!isEdited}
                  />
                  {/* <Button
											id="draft-btn"
											text="Draft"
											className="margin-small"
											variant="bordered"
											onClick={() => {
												const data = exportData();
												props.addNotes({
													pages: { ...data },
													isDraft: true
												});
											}}
											disabled={false}
										/> */}
                </section>
              </footer>
            </>
          )}
        </div>
      )}
    </>
  );
}
export default memo(PDFRenderer);
// export default PDFRenderer;

function PDFrendererSuspense() {
  return (
    <main className="inherit-parent-width padding-medium ">
      <ul className="margin-top-larger margin-bottom-larger list-style-none">
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "80%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "90%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "70%", height: "2vh" }}
        ></li>
      </ul>
      <ul className="margin-top-larger margin-bottom-larger padding-vertical-larger list-style-none">
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "80%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "90%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "70%", height: "2vh" }}
        ></li>
      </ul>
      <ul className="margin-top-larger margin-bottom-larger list-style-none">
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "80%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "90%", height: "2vh" }}
        ></li>
        <li
          className="padding-right-large shimmer margin-bottom-default"
          style={{ width: "70%", height: "2vh" }}
        ></li>
      </ul>
    </main>
  );
}
